module.exports = __webpack_public_path__ + "static/media/emptyBrowserIcon.65f180fa.svg";